import { request } from "../_helpers/Auth";

const namespace = "/api";

export const getHolidaysEstablishment = (_id) => {
    return request({
        url: namespace + "/holidays/establishment/" + _id,
        method: "get",
    });
};

export const attachHoliday = (establishment_id, payload) => {
    return request({
        url: namespace + "/establishment/" + establishment_id + "/holiday",
        data: payload,
        method: "post",
    });
};

export const deleteHoliday = (establishment_id, holiday_id) => {
    return request({
        url: namespace + "/establishment/" + establishment_id + "/holiday/" + holiday_id,
        method: "delete",
    });
};